import { Injectable } from '@angular/core';
import { WhitelabelService } from '@galaxy/partner';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, switchMap } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';
import { AccessService, Feature } from 'marketplace-ui';

@Injectable()
export class StubAccessService implements AccessService {
  features: Observable<string[]>;

  constructor(
    private app: AppConfigService,
    private whitelabelService: WhitelabelService,
  ) {
    this.features = this.app.config$.pipe(
      map((config) => config.partnerId),
      switchMap((partnerId) => this.whitelabelService.getConfiguration(partnerId)),
      map((config) => config.enabledFeatures),
      shareReplay(1),
    );
  }

  // note: this should not to be confused with `vconfig/vconfig.service.ts`
  // this is for value based pricing feature access checks
  hasAccessToFeature(feature: Feature): Observable<boolean> {
    return this.features.pipe(
      map((features) => {
        return Boolean(features && features.indexOf(feature) >= 0);
      }),
      distinctUntilChanged(),
    );
  }

  // note: this should not to be confused with `vconfig/vconfig.service.ts`
  // this is for value based pricing feature access checks
  hasAccessToFeatures(features: Feature[]): Observable<boolean> {
    if (!features) {
      return of(true);
    }
    return this.features.pipe(
      map((partnerFeatures) => {
        return features.every((feature) => Boolean(partnerFeatures && partnerFeatures.indexOf(feature) >= 0));
      }),
      distinctUntilChanged(),
    );
  }
}
